import { getHexColorByHue } from './color-utils'

export const AndroidHuePreviewComponent = {
    bindings: {
        hue: "<",
        name: "<"
    },
    template: `<apex-color-preview color="$ctrl.color" name="$ctrl.name"></apex-color-preview>`,
    controller: class AndroidHuePreview {
        $onInit() {
            this.color = getHexColorByHue(this.hue)
        }
        $onChanges(changesObj) {
            if (changesObj.hue) {
                this.color = getHexColorByHue(this.hue)
            }
        }
    }
}
